// ISDP CUSTOM: reusable profile avatar. Renders, in order of preference:
//   1. the provider (Okta) profile picture,
//   2. the user's initials, or
//   3. the core::user icon (guest / no name).
// Used in the top-nav profile button (Root.tsx) and the Settings profile card.
import { useState } from 'react';
import { useProfileInfo } from './useProfileInfo';
import './DevHubSettings.css';

export function ProfileAvatar({
  size = 28,
  className,
}: {
  /** Rendered square size in px. */
  size?: number;
  className?: string;
}) {
  const { picture, initials, loading } = useProfileInfo();
  const [imgFailed, setImgFailed] = useState(false);

  const style = { width: size, height: size };
  const cls = `devhub-avatar${className ? ` ${className}` : ''}`;

  if (picture && !imgFailed) {
    return (
      <img
        className={cls}
        style={style}
        src={picture}
        alt=""
        referrerPolicy="no-referrer"
        onError={() => setImgFailed(true)}
      />
    );
  }

  if (!loading && initials) {
    return (
      <span
        className={`${cls} devhub-avatar--initials`}
        style={{ ...style, fontSize: Math.round(size * 0.4) }}
        aria-hidden="true"
      >
        {initials}
      </span>
    );
  }

  // Fallback: the original account icon (also covers the loading window).
  return (
    <span className={`${cls} devhub-avatar--icon`} style={style} aria-hidden="true">
      <odx-icon className="odx-icon" name="core::user" />
    </span>
  );
}
